import { ArrowLeft } from "lucide-react";
import { useState } from "react";
import ReportGroupUnits from "./ReportGroupUnits.tsx";
// import ReportGroupSubs from "./reportGroupSubs";
import ReportGroupSubs from "./ReportGroupsSubs.tsx";
type ReportGroup = {
  id: string;
  name: string;
  description: string;
  devices: number;
  date_created: string;
};

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
}

interface ReportGroupDetailsProps {
  group: ReportGroup | null;
  onBack: () => void;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return value === index ? <div>{children}</div> : null;
}

export default function ReportGroupDetails({
  group,
  onBack,
}: ReportGroupDetailsProps) {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <div className="w-full flex flex-col rounded-lg bg-slate-900">
      <div className="w-full p-4 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button
              onClick={onBack}
              className="p-2 rounded hover:bg-gray-700 text-white"
            >
              <ArrowLeft size={24} />
            </button>
            <div className="flex items-center gap-2">
              <span className="text-lg font-semibold">
                Report Group: {group?.name || "Group Details"}
              </span>
              <span className="px-3 py-1 bg-blue-600 text-white text-sm rounded-full">
                {group?.devices || 0} units
              </span>
            </div>
          </div>
        </div>

        <div className="p-2 bg-transparent min-h-[73vh] rounded-lg">
          {/* Tabs */}
          <div className="flex border-b border-gray-600 mb-4">
            <button
              onClick={() => handleTabChange(0)}
              className={`px-6 py-3 font-medium transition-colors relative ${
                tabIndex === 0
                  ? "text-blue-400 border-b-2 border-blue-400"
                  : "text-gray-400 hover:text-gray-300"
              }`}
            >
              Units
            </button>
            <button
              onClick={() => handleTabChange(1)}
              className={`px-6 py-3 font-medium transition-colors relative ${
                tabIndex === 1
                  ? "text-blue-400 border-b-2 border-blue-400"
                  : "text-gray-400 hover:text-gray-300"
              }`}
            >
              Subscribers
            </button>
          </div>

          {/* Tab Panels */}
          <TabPanel value={tabIndex} index={0}>
            <ReportGroupUnits group={group} />
          </TabPanel>

          <TabPanel value={tabIndex} index={1}>
            <ReportGroupSubs group={group} />
          </TabPanel>
        </div>
      </div>
    </div>
  );
}
